import { useNavigate, useLocation } from 'react-router-dom'
import { FiClock, FiArrowRight } from 'react-icons/fi'

const TrialBanner = ({ empresaInfo }) => {
  const navigate = useNavigate()
  const location = useLocation()

  // No mostrar el botón si ya estamos en la página de plan
  const enPaginaPlan = location.pathname.includes('/configuracion')

  if (!empresaInfo || empresaInfo.subscription_status !== 'trialing' || !empresaInfo.trial_ends_at) {
    return null
  }

  const now = new Date()
  const trialEnd = new Date(empresaInfo.trial_ends_at)
  const diasRestantes = Math.max(0, Math.ceil((trialEnd - now) / (1000 * 60 * 60 * 24)))

  // Si ya expiró, no mostrar (el banner rojo de bloqueado se encarga)
  if (diasRestantes <= 0) return null

  let bgColor, textColor, message, urgency
  if (diasRestantes > 7) {
    bgColor = 'bg-blue-50 border-blue-200'
    textColor = 'text-blue-700'
    urgency = 'info'
    message = `Periodo de prueba gratuita. Te quedan ${diasRestantes} días.`
  } else if (diasRestantes > 3) {
    bgColor = 'bg-amber-50 border-amber-200'
    textColor = 'text-amber-700'
    urgency = 'warning'
    message = `Tu prueba gratis termina en ${diasRestantes} días.`
  } else {
    bgColor = 'bg-red-50 border-red-200'
    textColor = 'text-red-700'
    urgency = 'urgent'
    message = diasRestantes === 1
      ? 'Tu prueba gratis termina mañana.'
      : `Tu prueba gratis termina en ${diasRestantes} días.`
  }

  return (
    <div className={`${bgColor} border rounded-xl px-4 py-2.5 mb-4 flex items-center justify-between gap-3`}>
      <div className={`flex items-center gap-2 ${textColor} text-sm`}>
        <FiClock className={`h-4 w-4 shrink-0 ${urgency === 'urgent' ? 'animate-pulse' : ''}`} />
        <span className="font-medium">{message}</span>
      </div>
      {!enPaginaPlan && (
        <button
          onClick={() => navigate('/configuracion?tab=plan')}
          className={`shrink-0 flex items-center gap-1 px-3 py-1.5 rounded-lg text-xs font-bold transition-colors ${
            urgency === 'info'
              ? 'bg-blue-600 text-white hover:bg-blue-700'
              : urgency === 'warning'
              ? 'bg-amber-600 text-white hover:bg-amber-700'
              : 'bg-red-600 text-white hover:bg-red-700'
          }`}
        >
          Elegir plan
          <FiArrowRight className="h-3 w-3" />
        </button>
      )}
    </div>
  )
}

export default TrialBanner
